/** Normalize SMB UNC paths so doubled separators do not break share parsing server-side. */
export function normalizeSmbUncPath(path: string): string {
  const value = path.trim().replace(/\//g, '\\').replace(/\\+$/g, '');
  const body = value.replace(/^\\+/, '');
  const parts = body.split('\\').map((part) => part.trim()).filter((part) => part.length > 0);
  if (parts.length === 0) return '';
  return `\\\\${parts.join('\\')}`;
}
